<template>
  <stock-analysis />
</template>

<script>
import StockAnalysis from "../components/stock/StockAnalysis.vue";
export default {
  name: "Stock",
  components: {
    StockAnalysis,
  },
};
</script>

<style>
</style>